import { Slide, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef, useState } from "react";
import { MessageText, PromotionsContainer } from "../styles/promotiom";
import { Colors } from "../styles/promotiom";

const messages = [
  "שיינ'ס סטוק - עולם של יצירה",
  " שיינ'ס סטוק - הקניה הזולה ביותר",
  "הנחה מיוחדת למוסדות וגננות ",
];

export default function Promotions() {
  const containerRef = useRef();
  const [show, setShow] = useState(true);
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    setTimeout(() => setShow(false), 3000);

    const intervalId = setInterval(() => {
      setMessageIndex((i) => (i + 1) % messages.length);
      setShow(true);
      setTimeout(() => setShow(false), 3000);
    }, 4000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <PromotionsContainer 
    ref={containerRef}
    sx={{ borderRadius: 2 ,
      overflow: 'hidden',
      width: '100%',
      maxWidth: '1300px',
      mx: 'auto',
      my: 2,
    minHeight:10,
    }}
    >
      {/* רקע אפור + קצוות מעוגלים */}
      <Box
        sx={{
          bgcolor: "#f2f5f7",   // אפור עדין
          // borderRadius: 4,      // קצוות עגולים
          px: 2,
          py: 0.75,
        }}
      >
        <Slide
          direction={show ? "left" : "right"}
          in={show}
          container={containerRef.current}
          timeout={{ enter: 500, exit: 200 }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            {/* כיתוב ורוד */}
            <MessageText sx={{ color: "#D81B60", fontWeight: 600 }}>
              {messages[messageIndex]}
            </MessageText>
          </Box>
        </Slide>
      </Box>
    </PromotionsContainer>
  );
}
